import { useTranslation } from 'react-i18next'
import type { LineView } from './buildLineView'

/** "Bakerloo line" for Tube / Overground lines, the bare name otherwise ("DLR", "Elizabeth line"). */
export function useLineTitle(view: Pick<LineView, 'name' | 'nameTakesLineSuffix'>): string {
  const { t } = useTranslation('line-details')
  return view.nameTakesLineSuffix ? t('line_title', { name: view.name }) : view.name
}
